class ClaroluzEventDispatch {
    constructor(event: string, data?: object) {
        if (data) {
            data = {detail: data};
        }

        const customEvent = new CustomEvent(event, data || undefined);
        document.dispatchEvent(customEvent);
    }
}

//removeIf(production)
export default ClaroluzEventDispatch;
//endRemoveIf(production)